import * as yup from 'yup';
import { EmailSchema } from './share';

// Password Schema
export default yup.object().shape({
  email: EmailSchema
});
